export enum DisabledWidgetStatus {
  DEFAULT = 'default',
  NO_AUTH_TOKEN = 'noAuthToken',
  ANONYMOUS_SESSION_EXPIRED = 'anonymousSessionExpired'
}

export type TDisabledWidgetStatus = keyof typeof DisabledWidgetStatus;
